import { legacyPlugins } from "/codebuild/output/src2102781215/src/codestar-connections.eu-central-1.amazonaws.com/git-http/590183747426/eu-central-1/94facd3c-401c-440c-99a1-7824e47bf76e/studyportals/OmniSearch/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}